import React from 'react';
import { connect } from 'react-redux';
import { Spin, Tag } from 'antd';
import intl from 'react-intl-universal';
import { setSelectedRoom, setListFilterParams } from '@/redux/actions/bill';

import { ORDER_ROOM_STATE_MAP } from './config';
import styles from './index.module.scss';

function Rooms(props) {
  const { roomsLoading, rooms, selectedRoom } = props;

  const tagColor = (status) => {
    let color = 'success';
    switch (status) {
      case 1:
        color = 'warning';
        break;
      case 2:
        color = 'default';
        break;
      case 3:
        color = 'success';
        break;
      case 4:
        color = 'default';
        break;
      default:
        color = 'success';
    }
    return color;
  };

  const selectRoom = (room) => {
    // reset filter params
    props.setListFilterParams({
      type: -1, // 入账类型（全部
      status: -1, // 结账状态（全部）
      subjectCode: 'all', // 账务项目（全部）
    });
    // store selected room
    props.setSelectedRoom({
      roomId: room.roomId,
      roomNo: room.roomNo,
      recNo: room.recNo,
      status: room.status,
      priceChannel: room.priceChannel,
      occType: room.occType,
      roomTypeId: room.roomTypeId,
    });
  };

  const renderRooms = (roomList) => {
    if (roomList.length === 0) return null;

    return roomList.map((room) => {
      return (
        <dd
          className={selectedRoom.recNo === room.recNo ? styles['bill-room-selected'] : ''}
          key={room.recNo}
          onClick={() => selectRoom(room)}
        >
          <div>
            <Tag color={tagColor(room.status)}>{ORDER_ROOM_STATE_MAP[room.status]}</Tag>
            <strong>{room.roomNo || intl.get('app_reservation_room_queue_no')}</strong>
          </div>
          <div style={{ marginTop: 8 }}>{room.roomTypeName}</div>
        </dd>
      );
    });
  };

  return (
    <Spin spinning={roomsLoading}>
      <div className={styles['bill-rooms']}>
        <header>{intl.get('bill_invoice_modal_room')}</header>
        <dl>
          <dt
            className={selectedRoom.roomId === 0 ? styles['bill-room-selected'] : ''}
            onClick={() => selectRoom({ roomId: 0 })}
          >
            {intl.get('bill_order_total')}
          </dt>
          {renderRooms(rooms)}
        </dl>
      </div>
    </Spin>
  );
}

const mapStateToProps = (state) => {
  const { roomsLoading, rooms, selectedRoom } = state.bill;
  return { roomsLoading, rooms, selectedRoom };
};

export default connect(mapStateToProps, { setSelectedRoom, setListFilterParams })(Rooms);
